<template>
  <transition v-on:enter="enter" v-on:leave="leave">
    <div class="popup-frame target-frame" @click="ifClose">
      <div
        class="js-popup popup-desires reviews-popup-reg target-box"
        v-if="deleteEvent"
      >
        <i
          @click="$emit('close', false)"
          class="fa-close reviews-popup-close"
        ></i>
        <div class="reviews-popup-content">
          <div class="reviews-popup-title">
            <i class="fa-title"></i>
            <h3>{{ deleteEventText || $t("delete_course_confirm") }}</h3>
          </div>
          <div class="reviews-popup-button">
            <a href="#" class="logout" @click.prevent="$emit('delete', true)"
              >{{ $t("delete") }} <i class="fa-close"></i
            ></a>
            <a href="#" class="cart-reg" @click.prevent="$emit('close', false)"
              ><span>{{ $t("cancel") }}</span></a
            >
          </div>
        </div>
      </div>
      <div
        class="js-popup popup-out reviews-popup-reg target-box"
        v-if="logoutEvent"
      >
        <i
          @click="$emit('close', false)"
          class="fa-close reviews-popup-close"
        ></i>
        <div class="reviews-popup-content">
          <div class="reviews-popup-title">
            <i class="fa-title"></i>
            <h3>{{ $t("want_to_logout") }}</h3>
          </div>
          <div class="reviews-popup-button">
            <a href="#" @click.prevent="$emit('logout', true)" class="logout"
              >{{ $t("exit") }} <i class="fa-out"></i
            ></a>
            <a href="#" @click.prevent="$emit('close', false)" class="cart-reg"
              ><span>{{ $t("stay_on_page") }}</span></a
            >
          </div>
        </div>
      </div>
      <div
        class="js-popup popup-out reviews-popup-reg reviews-popup-custom target-box"
        v-if="reviewsEvent"
      >
        <i
          @click="$emit('close', false)"
          class="fa-close reviews-popup-close"
        ></i>
        <div class="reviews-popup-content reviews-popup">
          <div class="reviews-popup-title">
            <i class="fa-title"></i>
            <h3>{{ $t("leave_feedback") }}</h3>
          </div>

          <div class="reviews-popup-button user-button">
            <p>
              <span>{{ $t("rate_course") }}</span>
            </p>
            <div class="reviews-rates">
              <svg
                v-for="i in rates"
                :key="i"
                @mousemove="ratesHovered(i)"
                @mouseout="ratesHover = 0"
                @click="ratesActive = i"
                :class="{ hover: ratesHover >= i || ratesActive >= i }"
                width="21"
                height="19"
                viewBox="0 0 21 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.1271 0.306L13.6051 6.171L19.9491 6.716C20.3891 6.754 20.5681 7.303 20.2341 7.592L15.4221 11.761L16.8641 17.963C16.9641 18.394 16.4971 18.733 16.1191 18.504L10.6671 15.216L5.21506 18.504C4.83606 18.732 4.37006 18.393 4.47006 17.963L5.91206 11.761L1.09906 7.591C0.765063 7.302 0.943063 6.753 1.38406 6.715L7.72806 6.17L10.2061 0.306C10.3781 -0.102 10.9551 -0.102 11.1271 0.306Z"
                  fill="#EEA310"
                />
              </svg>
            </div>
            <div class="reviews-form">
              <textarea
                :placeholder="$t('leave_review_placeholder')"
                name="reviews"
                v-model="ratesText"
                @input="ratesError = false"
                class="user-input"
              ></textarea>
            </div>
            <small style="color: tomato" v-if="ratesError">{{
              $t("leave_comment")
            }}</small>
            <div class="user-button">
              <label class="user-form-sub">
                <input type="submit" @click.prevent="submitReviews" />{{
                  $t("submit")
                }}
                <i class="fa-out"></i>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Velocity from "velocity-animate";

export default {
  data() {
    return {
      rates: 5,
      ratesHover: 0,
      ratesActive: 1,
      ratesText: "",
      ratesError: false,
    };
  },
  props: {
    deleteEvent: {
      type: Boolean,
      default: false,
    },
    deleteEventText: {
      type: String,
      default: "",
    },
    logoutEvent: {
      type: Boolean,
      default: false,
    },
    reviewsEvent: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    enter: function (el, done) {
      Velocity(
        el,
        "fadeIn",
        {
          duration: 200,
          easing: "easeInBack",
        },
        { complete: done },
      );
    },

    leave: function (el, done) {
      Velocity(
        el,
        "fadeOut",
        {
          duration: 200,
          easing: "easeInBack",
        },
        { complete: done },
      );
    },
    ratesHovered(e) {
      this.ratesHover = e;
    },
    submitReviews() {
      if (this.ratesText === "") {
        this.ratesError = true;
        return;
      }
      this.$emit("reviews", {
        rates: this.ratesActive,
        desc: this.ratesText,
      });
      this.$emit("close", false);
    },
    ifClose(e) {
      if (e.target.classList.contains("popup-frame")) {
        this.$emit("close", false);
      }
    },
  },
};
</script>
